import logo from './logo.svg';
import './App.css';
import LinearProgress from '@mui/material/LinearProgress';
import {Routes,Route,Navigate,Outlet,useNavigate} from 'react-router-dom'
import {useState,useEffect,useRef,useCallback,React,Suspense,lazy} from "react"
import Stack from '@mui/material/Stack';
import { useDispatch,useSelector } from 'react-redux';
import axios from 'axios';
import {apicall} from './Redux/MiddlewareReduxThunk/AllderfermentWmiddlew'
import {sexamSchedule} from './Redux/MiddlewareReduxThunk/SexamScheduleRthunk'
import {allProgramthunk} from './Redux/MiddlewareReduxThunk/LoadprogramsRthunk'
// import setStudents from './Redux/Actions/studentAction'
import { ContextRecords } from './ContextAPI/ContextRecords';
import store from './Redux/Store/Store'
import { use } from 'react';
const History=lazy(()=> import('./components/History'))
const Attendance=lazy(()=> import('./components/Attendance'))
const Mystudents=lazy(()=> import('./components/Mystudents'))

const Setting=lazy(()=> import('./components/Setting'))
const Login=lazy(()=> import('./components/Login'))
const Layout=lazy(()=> import('./components/Layout'))
const Createuser=lazy(()=> import('./components/Createuser'))
const AppBar=lazy(()=> import('./components/AppBar'))
const Home=lazy(()=> import('./components/Home'))
const Listofuser=lazy(()=> import('./components/Listofuser'))
const Bulkfile=lazy(()=> import('./components/Bulkfile'))
const Underhistory=lazy(()=> import('./components/Underhistory'))
const Centrestatistic=lazy(()=> import('./components/Centrestatistic'))
const ExaminationCentreStatistics = lazy(() => import('./components/ExaminationCentreStatistics'));
const Signout=lazy(()=> import('./components/Signout'))
const Filterissue=lazy(()=> import('./components/Filterissue'))
const Bulkprint=lazy(()=> import('./components/Bulkprint'))
const Courseattendance=lazy(()=> import('./components/Courseattendance'))
const Courseattence=lazy(()=> import('./components/Courseattence'))
const Defermentlist=lazy(()=> import('./components/Defermentlist'))
const Comfirmstatistic=lazy(()=> import('./components/Comfirmstatistic'))
const Tcler=lazy(()=> import('./components/Tcler'))
const Sofresultstranscript=lazy(()=> import('./components/Sofresultstranscript'))
const SofresultUpload=lazy(()=> import('./components/SofresultUpload'))
const TranscriptDownload=lazy(()=> import('./components/TranscriptDownload'))
const Rank=lazy(()=> import('./components/Rank'))
const Addinvigilator=lazy(()=> import('./components/Addinvigilator'))
const Mileage=lazy(()=> import('./components/Mileage'))
const Asigntask=lazy(()=> import('./components/Asigntask'))
const Studentprojectprog=lazy(()=> import('./components/Studentprojectprog'))
const PaymentReceipt=lazy(()=> import('./components/PaymentReceipt'))
const RemoteScreen=lazy(()=> import('./components/RemoteScreen'))
const Super=lazy(()=> import('./components/Super'))
const MyProject=lazy(()=> import('./components/MyProject'))
const Dhistory=lazy(()=> import('./components/Dhistory'))
const StudentsInfo=lazy(()=> import('./components/StudentsInfo'))
const ExamSupervisors=lazy(()=> import('./components/ExamSupervisors'))
const SupervisorSearch=lazy(()=> import('./components/SupervisorSearch'))
const Generatorlog=lazy(()=> import('./components/Generatorlog'))
const Paymentissues=lazy(()=> import('./components/Paymentissues'))
const ExamsGenerator=lazy(()=> import('./components/ExamsGenerator'))
const StaffTransfer=lazy(()=> import('./components/StaffTransfer'))
const ProjectPayment=lazy(()=> import('./components/ProjectPayment'))
const CbtConfiguration=lazy(()=> import('./components/CbtConfiguration'))
const ResetPassword=lazy(()=> import('./components/ResetPassword'))
const QuestionAuthoring=lazy(()=> import('./components/QuestionAuthoring'))
const AllCourseConfigurations=lazy(()=> import('./components/AllCourseConfigurations'))
const CbtResults=lazy(()=> import('./components/CbtResults'))
const InvigilatorScanner=lazy(()=> import('./components/InvigilatorScanner'))
const StudentScansStatistics=lazy(()=> import('./components/StudentScansStatistics'))
const ExaminationCentreStatisticsNew = lazy(() => import('./components/ExaminationCentreStatisticsNew'))
const Examstatisticsnewupdate = lazy(() => import('./components/Examstatisticsnewupdate'))
const AttendanceSheet = lazy(() => import('./components/ExamAttendanceSheet'))
const ExamSlipClosingDate = lazy(() => import('./components/ExamSlipClosingDate'))
const ManageFeatureAccess = lazy(() => import('./components/ManageFeatureAccess'))
const SubCentreAuditLog = lazy(() => import('./components/SubCentreAuditLog'))
const DefermentPaymentConfirm = lazy(() => import('./components/DefermentPaymentConfirm'))

// Attach JWT token to every axios request — reads fresh from localStorage each time
axios.interceptors.request.use((config) => {
  try {
    const stored = localStorage.getItem('storejws');
    if (stored) {
      const token = JSON.parse(stored)?.kaijwt;
      if (token) config.headers['Authorization'] = `Bearer ${token}`;
    }
  } catch (_) {}
  return config;
});

const IDLE_TIMEOUT = 60 * 60 * 1000; // 1 hour

const PrivateRoute = () => {
  const navigate = useNavigate();
  const timerRef = useRef(null);

  const logout = useCallback(() => {
    localStorage.removeItem("storejws");
    navigate("/", { replace: true });
  }, [navigate]);

  const resetTimer = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(logout, IDLE_TIMEOUT);
  }, [logout]);

  useEffect(() => {
    if (!localStorage.getItem("storejws")) return;

    const events = ["mousemove", "keydown", "mousedown", "scroll", "touchstart", "click"];
    events.forEach(e => window.addEventListener(e, resetTimer));
    resetTimer();

    return () => {
      events.forEach(e => window.removeEventListener(e, resetTimer));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [resetTimer]);

  return localStorage.getItem("storejws") ? <Outlet /> : <Navigate to="/" replace />;
};

function App() {
const [loadschdulr,setLoadschdulr]=useState([])

const [timetabled,setTimetabled]=useState([])
const [loaddeferment,setLoaddeferment]=useState([])
const [allLoaddeferment,setAllLoaddeferment]=useState([])
const [studentsall,setStudentsall]=useState([])
const [rankdata,setRankdata]=useState([]);
const [checkupdate,setCheckupdate]=useState(0);
const storein=localStorage.getItem("storejws");
const jabi=JSON.parse(storein);
// console.log('jabi', jabi)
let whoisthis;
let username;
let uid;
   if(jabi!=null){
 whoisthis=jabi.privilage;
 username=jabi.username;
 uid=jabi.rule;
   }

const [recordsuser, setRecordsuser] = useState([]);


const [skeloton, setSkeloton] = useState(0);

const [showpost, setShowpost] = useState([]);
const [statcheck,setStatcheck]=useState(0)
const [pulsrecord,setPulsrecord]=useState([])
const [loadprog,setLoadprog]=useState([])
const [studentlist,setStudentlist]=useState([])
useEffect(()=>{

  //console.log("mubi",userid)
      axios.post(process.env.REACT_APP_UNIVERSAL_URL+"/getpostuser.php",{conter:100,filter:1,userid:uid}).then((result)=>{
           if(result.data.length !=0){
            setShowpost(result.data)
           }
      }).catch(()=>{
      }).finally(()=>{
        setSkeloton(1)
      })
      
      
      //alert(showpost2)
      
  },[])
useEffect(()=>{

  
  
  axios.get(process.env.REACT_APP_UNIVERSAL_URL+"/getRanks.php").then((result)=>{
     console.log("Arewa:::",result)
      if(result.data.length>=1){
        setRankdata(result.data)
        setCheckupdate(0)
      }
   });  

},[checkupdate])
  useEffect(()=>{  
    store.dispatch(apicall());
    store.dispatch(sexamSchedule())
    store.dispatch(allProgramthunk())



  //  axios.get(process.env.REACT_APP_UNIVERSAL_URL+"/loadprog.php").then((result)=>{
  //   //console.log("ram Niger2:",result)
  //   if(result.data.length>=1){
          
  //           setLoadprog(result.data)
  //        // console.log("jakoli:::",result.data)
  //       } else{

        
  //       }
  //    });


     axios.get(process.env.REACT_APP_UNIVERSAL_URL+"/Timetableload.php").then((result)=>{
      //  console.log("ram Niger21:",result)
        if(result.data.length>=1){
              
          setTimetabled(result.data)
             // console.log("jakoli:::",result.data)
            } else{
    
            
            }
         });


        

 


    },[])


   
    const seethestore=useSelector(state=>state)
    const [invigilator,setInvigilator]=useState([]);
    const [loadstate,setLoadstate]=useState([]);
    const [mileage,setMileage]=useState([]);
    const [projectlist,setProjectlist]=useState([]);
    const [postlist,setPostlist]=useState([]);

    // console.log("See the thunk2",seethestore)
    useEffect(()=>{

    //  console.log("See the thunk",seethestore)

      // axios.get(process.env.REACT_APP_UNIVERSAL_URL+"/loadallderferment.php").then((result)=>{
      //   console.log("all Bukar asali1111:",result)
      //    if(result.data.length>=1){
               
      //      setAllLoaddeferment(result.data)
      //         // console.log("jakoli:::",result.data)
      //        } else{
     
             
      //        }
      //     });


          
    


        axios.get(process.env.REACT_APP_UNIVERSAL_URL+"/loadinvigilator.php").then((result)=>{
        // console.log("invigilator kai nas!!!:",result)
         if(result.data.length>=1){
          setInvigilator(result.data)
          //  setAllLoaddeferment(result.data)
              // console.log("jakoli:::",result.data)
             } else{
     
             
             }
          });



          axios.get(process.env.REACT_APP_UNIVERSAL_URL+"/Stateobj.php").then((result)=>{
            //  console.log("load state!!!:",result)
             if(result.data.length>=1){
              setLoadstate(result.data)
                 } else{
         
                 
                 }
              });



              axios.get(process.env.REACT_APP_UNIVERSAL_URL+"/loadmailege.php").then((result)=>{
                console.log("load loadmailage!!!:",result)
                 if(result.data.length>=1){
                  setMileage(result.data)
                     } else{
             
                     
                     }
                  });

    },[checkupdate])
    const dispatch=useDispatch();      

 // setStudentSched
// console.log("rajas1",loadschdulr)
//console.log("rajas2",timetabled)
// dispatch(setStudentSched(loadschdulr))
// dispatch(setProgram(loadprog))
// dispatch(setTimetable(timetabled))
// dispatch(setDeferment(loaddeferment))
//dispatch(setAlldefermentAction(allLoaddeferment))
//dispatch(setStudents(studentsall))

// console.log('alobadi', rankdata)



useEffect(()=>{
     
  if(whoisthis==1){  
axios.get(process.env.REACT_APP_UNIVERSAL_URL+"/loadprog.php").then((result)=>{
    // console.log("Programs nas:",result.data.abbr)
  
  //  setLoadprogram(result.data)
    if(result.data.length>0){
      setLoadprog(result.data)
 
    }else{


      // alert("Records not found!")
      //setLetseethem('Record not found!')
  //    navigate('/');
    }

});

}else if(whoisthis==2){

axios.post(process.env.REACT_APP_UNIVERSAL_URL+"/loadprogbutduties.php",{email:username }).then((result)=>{
  //  console.log("Programs nas111:",result.data)

//  setLoadprogram(result.data)
  if(result.data.length>0){
    setLoadprog(result.data)

  }else{


    // alert("Records not found!")
    //setLetseethem('Record not found!')
//    navigate('/');
  }

});
}

setStatcheck(1)
axios.get(process.env.REACT_APP_UNIVERSAL_URL+"/loadstatusadmin.php").then((result)=>{
 // console.log("zali",result)
//    let fname=result.data[0].fname;
setPulsrecord(result.data)
setStatcheck(0)

 });
},[])

const [loadmaster,setLoadmaster]=useState(0);
const [loadsuper,setLoadsuper]=useState([]);
const [students,setStudents]=useState([]);
const [remote,setRemote]=useState([]);




useEffect(()=>{



  axios.get(process.env.REACT_APP_UNIVERSAL_URL+"/Remoteadmin.php").then((result)=>{
    //  console.log("zali",result)
   //    let fname=result.data[0].fname;
  //  setPulsrecord(result.data)
  //  setStatcheck(0)
  setRemote(result.data)
    });
},[])


useEffect(()=>{

  axios.post(process.env.REACT_APP_UNIVERSAL_URL+"/loadsupervisor.php",{username:username})
    .then((result)=>{
      const data = Array.isArray(result.data) ? result.data : [];
      if(data.length > 0){
        setLoadsuper(data);
      }
      // silently ignore empty — component shows "No supervisors found" placeholder
    })
    .catch((err)=>{
      console.error("loadsupervisor.php failed:", err);
    });



  axios.get(process.env.REACT_APP_UNIVERSAL_URL+"/projectlist.php")
    .then((result)=>{
      const data = Array.isArray(result.data) ? result.data : [];
      if(data.length > 0){
        setProjectlist(data);
      }
    })
    .catch((err)=>{
      console.error("projectlist.php failed:", err);
    });

},[loadmaster])


useEffect(()=>{
 
          axios.get(process.env.REACT_APP_UNIVERSAL_URL+"/postlist.php").then((result)=>{
            //  console.log("students:",result)
        //  alert(1)
               
              setPostlist(result.data)
                  // console.log("jakoli:::",result.data)
                
              });



  
},[loadmaster])
useEffect(()=>{
  axios.post(process.env.REACT_APP_UNIVERSAL_URL+"/loadstu2.php",{username:username}).then((result)=>{
    //  console.log("zali222",result)
   //    let fname=result.data[0].fname;
   setStudents(Array.isArray(result.data) ? result.data : [])
   
   
    });

 
},[])
  return (
<>


<ContextRecords.Provider  value={{postlist,remote,projectlist,students,loadsuper,setLoadmaster,loadprog,pulsrecord,statcheck,rankdata,setCheckupdate,invigilator,loadstate,mileage,showpost,skeloton,studentlist}}>

{/* <Rank /> */}

<Routes>

{/* Public routes - accessible without login */}
<Route path="/"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
    <LinearProgress color="secondary" />
    <LinearProgress color="success" />
    <LinearProgress color="inherit" />
  </Stack></div>} ><Login /></Suspense>}  />

<Route path="/reset-password" element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
    <LinearProgress color="secondary" />
    <LinearProgress color="success" />
    <LinearProgress color="inherit" />
  </Stack></div>} ><ResetPassword /></Suspense>}  />

<Route path="/invigilator-scan" element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
    <LinearProgress color="secondary" />
    <LinearProgress color="success" />
    <LinearProgress color="inherit" />
  </Stack></div>} ><InvigilatorScanner /></Suspense>}  />

{/* Protected routes - redirect to "/" if not logged in */}
<Route element={<PrivateRoute />}>





{/* <ContextRecords.Provider > */}

<Route path="/rank"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><Rank /></Suspense>}  />

    <Route path="/deferment-payment-confirm"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><DefermentPaymentConfirm /></Suspense>}  />
    
    
    

    <Route path="/studentprojectprog"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><Studentprojectprog /></Suspense>}  />



    
    <Route path="/projectsuper"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><Super /></Suspense>}  />

    <Route path="/myproject"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><MyProject /></Suspense>}  />

    <Route path="/projectpayment"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><ProjectPayment /></Suspense>}  />


<Route path="/asigntask"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><Asigntask /></Suspense>}  />
    <Route path="/mileage"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><Mileage /></Suspense>}  />
 

    
    
    <Route path="/addinvigilator"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><Addinvigilator /></Suspense>}  />

    
<Route path="/comfirmstatistic/:centre"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><Comfirmstatistic /></Suspense>}  />

    
    <Route path="/sofresultstranscript"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><Sofresultstranscript /></Suspense>}  />

    <Route path="/sofresult-upload"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><SofresultUpload /></Suspense>}  />

    <Route path="/acadamic-request"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><TranscriptDownload /></Suspense>}  />

    <Route path="/supervisorSearch"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><SupervisorSearch /></Suspense>}  />


    
    <Route path="/generatorlog"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><Generatorlog /></Suspense>}  />

    <Route path="/examsgenerator"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><ExamsGenerator /></Suspense>}  />

    <Route path="/examsupervisors"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><ExamSupervisors /></Suspense>}  />




  <Route path="/paymentissues"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
    <LinearProgress color="secondary" />
    <LinearProgress color="success" />
    <LinearProgress color="inherit" />
  </Stack></div>} ><Paymentissues /></Suspense>}  />

  <Route path="/secondoption/:regNo/:rule/:tran"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
    <LinearProgress color="secondary" />
    <LinearProgress color="success" />
    <LinearProgress color="inherit" />
  </Stack></div>} ><Tcler /></Suspense>}  />

  

  <Route path="/mystudents"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><Mystudents /></Suspense>}  />

    
  <Route path="/studentsInfo/:regno/:transatid/:sessionid"  element={ <Suspense fallback={<div>Loading...</div>} ><StudentsInfo /> </Suspense>}  />

  <Route path="/payment-receipt/:regno" element={<PaymentReceipt />} />


  

  <Route path="/courseattendance/:course/:centre/:myprogramsee/:wdate"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><Courseattendance /></Suspense>}  />

  <Route path="/bulkprint/:dateid/:centreid/"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
    <LinearProgress color="secondary" />
    <LinearProgress color="success" />
    <LinearProgress color="inherit" />
  </Stack></div>} ><Bulkprint /></Suspense>}  />





  <Route path="/examstatisticsnewupdate"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><Examstatisticsnewupdate /></Suspense>}  />
  <Route path="/attendance-sheet" element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><AttendanceSheet /></Suspense>}  />
  <Route path="/examslipClosingdate"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><ExamSlipClosingDate /></Suspense>}  />
  <Route path="/managefeatureaccess"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><ManageFeatureAccess /></Suspense>}  />
  <Route path="/subcentre-audit-log"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><SubCentreAuditLog /></Suspense>}  />

  <Route path="/hadmin"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><Home /></Suspense>}  />

    

    <Route path="/dhistory/:regno"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><Dhistory /></Suspense>}  />

    <Route path="/defermentlist"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><Defermentlist /></Suspense>}  />


    <Route path="/courseattence"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><Courseattence /></Suspense>}  />



    <Route path="/filterissue/:idissue"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><Filterissue /></Suspense>}  />

  <Route path="/setting"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
         <LinearProgress color="secondary" />
         <LinearProgress color="success" />
         <LinearProgress color="inherit" />
       </Stack></div>} ><Setting /></Suspense>}  />

       <Route path="createuser"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
         <LinearProgress color="secondary" />
         <LinearProgress color="success" />
         <LinearProgress color="inherit" />
       </Stack></div>} ><Createuser /></Suspense>}  />
       <Route path="/listofuser"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
         <LinearProgress color="secondary" />
         <LinearProgress color="success" />
         <LinearProgress color="inherit" />
       </Stack></div>} ><Listofuser /></Suspense>}  />
   
       <Route path="/bulkfile"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
         <LinearProgress color="secondary" />
         <LinearProgress color="success" />
         <LinearProgress color="inherit" />
       </Stack></div>} ><Bulkfile /></Suspense>}  />
       <Route path="/history"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
         <LinearProgress color="secondary" />
         <LinearProgress color="success" />
         <LinearProgress color="inherit" />
       </Stack></div>} ><History /></Suspense>}  />
       <Route path="/underhistory"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
         <LinearProgress color="secondary" />
         <LinearProgress color="success" />
         <LinearProgress color="inherit" />
       </Stack></div>} ><Underhistory /></Suspense>}  />





       <Route path="/attendance"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
         <LinearProgress color="secondary" />
         <LinearProgress color="success" />
         <LinearProgress color="inherit" />
       </Stack></div>} ><Attendance /></Suspense>}  />



       
       <Route path="/remoteScreen"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
         <LinearProgress color="secondary" />
         <LinearProgress color="success" />
         <LinearProgress color="inherit" />
       </Stack></div>} ><RemoteScreen /></Suspense>}  />




      <Route path="/centrestatistic"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
                         <LinearProgress color="secondary" />
                         <LinearProgress color="success" />
                         <LinearProgress color="inherit" />
                       </Stack></div>} ><Centrestatistic /></Suspense>}  />

      <Route path="/examination-centre-statistics" element={
        <Suspense fallback={
          <div>
            <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
              <LinearProgress color="secondary" />
              <LinearProgress color="success" />
              <LinearProgress color="inherit" />
            </Stack>
          </div>
        }>
          <ExaminationCentreStatistics />
        </Suspense>
      } />
       <Route path="signout"  element={ <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
         <LinearProgress color="secondary" />
         <LinearProgress color="success" />
         <LinearProgress color="inherit" />
       </Stack></div>} ><Signout /></Suspense>}  />

  <Route path="/staff-transfer" element={
    <Suspense fallback={<div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
      <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
        <LinearProgress color="inherit" />
      </Stack>
    </div>}>
      <StaffTransfer />
    </Suspense>
  } />

  <Route path="/cbt-configuration" element={
    <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><CbtConfiguration /></Suspense>}  />

  <Route path="/question-authoring" element={
    <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><QuestionAuthoring /></Suspense>}  />

  <Route path="/all-course-configurations" element={
    <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><AllCourseConfigurations /></Suspense>}  />

  <Route path="/cbt-results" element={
    <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><CbtResults /></Suspense>}  />

  <Route path="/student-scans-statistics" element={
    <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><StudentScansStatistics /></Suspense>}  />

  <Route path="/examination-centre-statistics-new" element={
    <Suspense fallback={<div> <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="success" />
      <LinearProgress color="inherit" />
    </Stack></div>} ><ExaminationCentreStatisticsNew /></Suspense>}  />

</Route>{/* end PrivateRoute */}

</Routes>
</ContextRecords.Provider>
</>
  );
}

export default App;
